export const CanvasContextTypeMap = {
  canvas2d: '2d',
  webgl: 'webgl',
  webgl2: 'webgl2',
  webgpu: 'webgpu'
};